<template>
    <div>
        <div class="bread">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item style="cursor: pointer;" @click.native="handleBack">在线学习</el-breadcrumb-item>
                <el-breadcrumb-item>{{ info.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!--  <div class="livebanner">
            <iframe :src="info.pc_url" frameborder="0"></iframe>
        </div> -->
        <div class="banner-box">
            <div class="indexcon">
                <banner :banner="bannerList"></banner>
            </div>
            <!--   <el-carousel :height="bannerHeight" :autoplay="autoPlay" :interval="5000" arrow="hover"
                indicator-position="inside">
                <el-carousel-item v-for="(item, index) in " :key="index">
                    <div class="banner-item" @click="goLink(item.link)">
                        <img style="object-fit: cover;" :src="$img(item)" alt="" />
                    </div>
                </el-carousel-item>
            </el-carousel> -->
        </div>
        <div class="liveInfo">
            <div class="liveInner">
                <div class="infoTop flx alc jsb">
                    <div class="infoLeft">
                        <div class="leftTop" v-text="info.name"></div>
                        <div class="leftBottom" v-text="`直播时间:${info.begin_time_text}`"></div>
                    </div>
                    <div class="infoRight flx alc">
                        <div class="price" v-text="Number(info.price) === 0 ? '免费' : '￥' + info.price"></div>
                        <div class="buThis" @click="toopen" v-if="Number(info.price) > 0">马上购买</div>
                        <div class="buThis" @click="toopen" v-if="Number(info.price) === 0 && info.is_type === 1">马上观看</div>
                        <div class="buThis" @click="toopen" v-if="Number(info.price) === 0 && info.is_type === 2">观看回放</div>
                        <div class="buThis" @click="toopen" v-if="Number(info.price) === 0 && info.is_type === 3">马上预约</div>
						<div class="buThis" @click="toopen" v-if="Number(info.price) === 0 && info.is_type === 4">马上观看</div>
                    </div>
                </div>
                <div class="infoBottom flx" @click="shoucang">
                    <img :src="$Localimg('shou.png')" alt="" />
                    <div v-text="info.collect_status === 0 ? '收藏' : '已收藏'"></div>
                </div>
            </div>
        </div>
        <div class="advs" style="height: 176px;">
            <el-carousel height="176px" :autoplay="autoPlay" :interval="5000" arrow="never" indicator-position="inside">
                <el-carousel-item v-for="(item, index) in info.adv" :key="index">
                    <div class="banner-item" @click="goLink(item.url)">
                        <img :src="$img(item.image)" alt="" style="object-fit: cover;" />
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="liveintro flx jsb">
            <div class="introLeft">
                <div class="courseDes">
                    <!-- <div class="flx" style="justify-content: flex-start;" v-if="info.is_type != 0">
                        <div class="actitles">
                            <div class="actName" v-text="info.is_type == 2?'导师介绍':'企业介绍'"> </div>
                            <div class="bheng"></div>
                        </div>
                    </div>

                   <div class="conpms flx alc">
                       <div class="cava">
                           <img :src="$img(info.user_avatar)" alt="" />
                       </div>
                       <div class="caname" v-text="info.user_name"></div>
                       <i class="el-icon-arrow-right" style="font-size: 12px;color: #BFC0C2;flex: 1;margin-left: 12px;"></i>
                   </div> -->
                    <div class="flx" style="justify-content: flex-start;">
                        <div class="actitles">
                            <div class="actName">课程介绍</div>
                            <div class="bheng"></div>
                        </div>
                    </div>
                    <!-- 富文本：图片块级化 + 段落去 margin，解决图片上下空白 -->
                    <div class="comit" v-html="info.content"></div>
                </div>
            </div>
            <div class="introRight" v-if="info.recomm_live_list.length">
                <div class="bottomPart">
                    <div class="bpt">推荐直播</div>
                    <div class="reItem cursor"
                        v-for="(item, index) in info.recomm_live_list"
                        :key="item.id || index"
                        :style="index === info.recomm_live_list.length - 1 ? { border: 'none', marginBottom: 0 } : {}"
                        @click="toDetail(item)">
                        <div class="reImg">
                            <img :src="$img(item.pc_avatar)" alt="" />
                        </div>
                        <div class="reInfo">
                            <div class="reName multy2" v-text="item.name"></div>
                            <div class="reTitle single" v-text="item.begin_time_text"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getLiveDetail,
    collectlive,
    userInfo
} from "@/api/index.js"
import banner from "@/components/banner.vue"

export default {
    components: {
        banner
    },
    data() {
        return {
            id: "",
            bannerList: [],
            info: {
                recomm_live_list: []   // 默认空数组，避免模板中 .length 报错
            },
            bannerHeight: "500px", // 轮播高度自定义
            autoPlay: true,
        }
    },
    created() {
        this.id = this.$route.query.id
        this.getIndex()
    },
    watch: {
        '$route.query.id'(id) {
            if (id === this.id) return
            this.id = id
            this.getIndex()
        }
    },
    methods: {
        toopen() {
            userInfo().then((res) => {
                if (res.code === 1) {
                    window.open(this.info.pc_url)
                }
            })
        },
        handleBack() {
            if (window.history.length > 1) {
                this.$router.back()
            } else {
                this.$router.push('/')
            }
        },
        toDetail(e) {
            this.$router.push({
                path: '/liveDetail',
                query: {
                    id: e.id,
                    type: 1
                }
            })
        },
        shoucang() {
            collectlive(this.id).then((res) => {
                if (res.code === 1) {
                    this.$message.success(res.msg)
                    this.getIndex()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 点击图片跳转
        goLink(url) {
            // 判断是内部路由还是外部链接
            if (url.startsWith("http")) {
                window.open(url, "_blank")
            } else {
                this.$router.push(url)
            }
        },
        getIndex() {
            const id = this.id
            getLiveDetail(id).then((res) => {
                if (res.code === 1) {
                    this.info = res.data
                    // pc_images 可能缺失，做容错；forEach+push 简化为 map
                    this.bannerList = (res.data.pc_images || []).map((v) => ({
                        pc_image: v,
                        is_type: 1
                    }))
                    this.$nextTick(() => {
                        window.scrollTo(0, 0)
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
.banner-item img {
	width: 100% !important;
	height: auto !important;
}
/* ============ 通用布局 ============ */
.introRight {
    margin-left: 20px;
}

.livebanner {
    width: 100%;
    height: 787px;
    background-color: #000;
}

.livebanner iframe {
    width: 100%;
    height: 100%;
}

.liveintro {
    width: 1460px;
    margin: 20px auto;
}

.advs {
    width: 1460px;
    margin: 16px auto;
}

.advs img {
    width: 100%;
    height: 100%;
}

/* ============ Banner 轮播 ============ */
.banner-box {
    width: 100%;
}

.banner-item {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.banner-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* 深度修改轮播左右箭头背景 */
/deep/ .el-carousel__arrow {
    background-color: rgba(0, 0, 0, 0.6);
    width: 44px;
    height: 44px;
}

/deep/ .el-carousel__arrow:hover {
    background-color: rgba(0, 0, 0, 0.8);
}

/deep/ .el-carousel__arrow i {
    font-size: 20px;
    color: #fff;
}

/* ============ 直播信息 ============ */
.liveInfo {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 0;
    background-color: #fff;
}

.liveInner {
    width: 1460px;
    margin: 0 auto;
}

.leftTop {
    margin-bottom: 14px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    text-align: left;
}

.leftBottom {
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    text-align: left;
}

.price {
    margin-right: 20px;
    font-size: 20px;
    font-weight: 500;
    color: #FF252E;
}

.buThis {
    width: 169px;
    height: 38px;
    border-radius: 19px;
    background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
    text-align: center;
    line-height: 38px;
    color: #fff;
    cursor: pointer;
}

.infoBottom {
    margin-top: 25px;
    font-size: 12px;
    color: #333333;
}

.infoBottom img {
    width: 18px;
    height: 18px;
    margin-right: 4px;
}

/* ============ 课程介绍 / 富文本 ============ */
.introLeft {
    flex: 1;
    background: #fff;
}

.courseDes {
    width: 100%;
    box-sizing: border-box;
    padding: 26px;
}

.actitles {
    position: relative;
    display: inline-block;
    margin-bottom: 20px;
}

.actName {
    font-size: 18px;
    font-weight: 500;
    color: #3C464F;
}

.bheng {
    width: 24px;
    height: 4px;
    margin: 8px auto 0;
    background: #007AFF;
}

.comit {
    width: 100% !important;
}

/* 核心修复：富文本图片块级化，消除行内基线导致的上下空白 */
/* max-width 只防溢出，不再强制拉伸所有图片 */
.comit /deep/ img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0;
}

/* 富文本段落去掉默认 margin，图片不再被 p 间距撑出空白 */
.comit /deep/ p {
    margin: 0;
}

/* 段落之间保留少量间距 */
.comit /deep/ p + p {
    margin-top: 12px;
}

/* 以下样式对应上方被注释的旧模板，如需恢复注释代码可继续使用 */
.caname {
    width: 216px;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
    text-align: left;
}

.cava {
    width: 70px;
    height: 70px;
    margin-right: 15px;
}

.cava img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.conpms {
    width: 416px;
    height: 110px;
    box-sizing: border-box;
    padding: 20px;
    background: #F7F8F9;
    border-radius: 6px;
}

/* ============ 推荐直播 ============ */
.bottomPart {
    width: 332px;
    box-sizing: border-box;
    padding: 20px;
    background: #ffffff;
}

.bpt {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 600;
    text-align: left;
}

.reItem {
    width: 100%;
    margin-bottom: 20px;
    border-bottom: 1px solid #ececec;
}

.reImg {
    width: 292px;
    height: 164px;
}

.reImg img {
    width: 100%;
    height: 100%;
    border-radius: 6px;
}

.reInfo {
    box-sizing: border-box;
    padding: 12px 0 20px;
    text-align: left;
}

.reName {
    margin-bottom: 14px;
    font-size: 16px;
    font-weight: 600;
}

.reTitle {
    font-size: 14px;
    color: #919296;
}
</style>
